import { CurrentBalanceCompany, DebtTypeEnum } from 'src/types/inputs';
export enum inputIndex {
  DEBT_TYPE = 'debt_type',
  INSTITUTION = 'institution',
  AMOUNT = 'amount',
}

export type inputType = {
  index: string;
  debt_type: DebtTypeEnum | '';
  institution: CurrentBalanceCompany | '';
  amount: number | null;
  confirmed: boolean;
  isOpen: boolean;
};

export type SafeInputType = Omit<
  inputType,
  'debt_type' | 'institution' | 'amount'
> & {
  debt_type: DebtTypeEnum;
  institution: CurrentBalanceCompany;
  amount: number;
};
